import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "map" ]

  connect() {
    if (typeof(google) != "undefined") {
      this.initMap()
    }
  }

  initMap() {
    let position = new google.maps.LatLng(this.data.get("lat"), this.data.get("lng"))

    this.map = new google.maps.Map(this.mapTarget, {
      center: position,
      zoom: parseInt(this.data.get("zoom")) || 15
    })
    
    this.addMarker(position)
  }

  addMarker(position) {
    let marker = new google.maps.Marker({
      map: this.map,
      position: position
    })
  }
}